// extracted by mini-css-extract-plugin
export default {"container":"Yj-z","bubbleNav":"Zj-z","graphic":"_j-z","contact":"ak-z"};